// extracted by mini-css-extract-plugin
export default {"page":"sY-z","cartModal":"tY-z","checkout":"uY-z","placeholder":"vY-z","account":"wY-z"};